import React from 'react'

import { Grid } from '@mui/material'
import debounce from 'lodash/debounce'

import { FormTextField, FormToggle } from 'components/input'
import { withForm } from 'decorators/withForm'

const UsersFilters = () => (
  <Grid container spacing={2} style={{ width: '100%' }} sx={{ alignItems: 'center', justifyContent: 'flex-end' }}>
    <Grid>
      <FormToggle component="switch" label="Admin" name="admin" tooltip="Albacross Admin" />
    </Grid>
    <Grid>
      <FormToggle component="switch" label="Deleted" name="showDeleted" tooltip="Show deleted users" />
    </Grid>
    <Grid style={{ width: 300, minWidth: 200 }}>
      <FormTextField name="search" placeholder="Search..." />
    </Grid>
  </Grid>
)

export default withForm({
  form: 'usersFilters',
  onChange: debounce((values: any, _dispatch: any, props: any) => props.setFilters(values), 500),
})(UsersFilters)
